/* result-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./result-renderer.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SimpleTag as Tag } from '@atlaskit/tag';
import React from 'react';
import { Box } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { SearchResultContent } from '@atlassian/search-dialog';
import { ResultAvatar } from '../../../common/result-avatar';
import { defaultResultRenderer } from '../../../extensible/search-result/default-result-renderer';
import { ProductStates } from '../../product-state-machine/product-state-machine-types';
import { ResultIcon } from './result-icon';

/**
 * This function renders a component search result using the default component offered
 * by the search platform. Specifically, the SearchResultContent is used.
 *
 * We override this to use different size icons for pre query and post query states
 */
export var componentResultRenderer = function componentResultRenderer(args) {
  var _searchResult$icon$to, _searchResult$icon;
  var productState = args.productState,
    searchResult = args.searchResult;
  var iconSize = productState === ProductStates.PreQuerySuccess ? 'small' : 'medium';
  var iconType = (_searchResult$icon$to = (_searchResult$icon = searchResult.icon) === null || _searchResult$icon === void 0 ? void 0 : _searchResult$icon.toString()) !== null && _searchResult$icon$to !== void 0 ? _searchResult$icon$to : '';
  return defaultResultRenderer(_objectSpread(_objectSpread({}, args), {}, {
    searchResult: _objectSpread(_objectSpread({}, searchResult), {}, {
      icon: /*#__PURE__*/React.createElement(ResultIcon, {
        type: iconType,
        size: iconSize
      })
    })
  }));
};

/**
 * This function renders a people or team search result using the default component offered
 * by the search platform. Specifically, the SearchResultContent is used.
 *
 * We override this to use different size icons for pre query and post query states
 */
export var peopleAndTeamsResultRenderer = function peopleAndTeamsResultRenderer(args) {
  var productState = args.productState,
    searchResult = args.searchResult;
  var iconSize = productState === ProductStates.PreQuerySuccess ? 'xsmall' : 'small';
  return defaultResultRenderer(_objectSpread(_objectSpread({}, args), {}, {
    searchResult: _objectSpread(_objectSpread({}, searchResult), {}, {
      icon: /*#__PURE__*/React.createElement(ResultAvatar, {
        borderColor: "transparent",
        src: searchResult.iconUrl,
        appearance: "square",
        size: iconSize,
        testId: "result-avatar"
      })
    })
  }));
};
var MethodDetails = {
  POST: {
    abbreviation: 'POST',
    color: 'purpleLight'
  },
  GET: {
    abbreviation: 'GET',
    color: 'greenLight'
  },
  PUT: {
    abbreviation: 'PUT',
    color: 'blueLight'
  },
  DELETE: {
    abbreviation: 'DEL',
    color: 'redLight'
  },
  PATCH: {
    abbreviation: 'PATCH',
    color: 'greyLight'
  },
  OPTIONS: {
    abbreviation: 'OPT',
    color: 'greyLight'
  },
  HEAD: {
    abbreviation: 'HEAD',
    color: 'greyLight'
  },
  TRACE: {
    abbreviation: 'TRACE',
    color: 'greyLight'
  },
  CONNECT: {
    abbreviation: 'CONN',
    color: 'greyLight'
  }
};
var styles = {
  methodTag: "_18u0r5cr"
};
export var endpointResultRenderer = function endpointResultRenderer(args) {
  var searchResult = args.searchResult;
  var method = (typeof searchResult.icon === 'string' ? searchResult.icon : '').toUpperCase();
  var methodDetails = MethodDetails[method];
  var methodTag = /*#__PURE__*/React.createElement(Box, {
    xcss: styles.methodTag
  }, methodDetails ? /*#__PURE__*/React.createElement(Tooltip, {
    content: methodDetails.abbreviation
  }, /*#__PURE__*/React.createElement(Tag, {
    text: methodDetails.abbreviation,
    color: methodDetails.color
  })) : /*#__PURE__*/React.createElement(Tooltip, {
    content: 'OTHER'
  }, /*#__PURE__*/React.createElement(Tag, {
    text: 'OTHER',
    color: "greyLight"
  })));
  var title = /*#__PURE__*/React.createElement(Box, {
    paddingInlineStart: "space.300"
  }, searchResult.title);
  return /*#__PURE__*/React.createElement(SearchResultContent, {
    key: "item_".concat(searchResult.id),
    isKeyboardHighlighted: args.isKeyboardHighlighted,
    title: title,
    icon: methodTag,
    isCollapsed: args.isCollapsed,
    meta: searchResult.meta
  });
};